import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface IDeleteSectorsRequest {
  host: string;
  booking: {
    syscode: string;
    host: string;
    priceArray: {
      xId: string,
      key: string
    }[],
    segmentArray: {
      xId: string,
      key: string
    }[]
  },
  taskArray: {
    purpose: 'Delete' | 'Add',
    code: 'Segment' | 'Price',
    argumentArray: {
      ref: string, // segment id
      role: 'Delete' | 'Add'
    }[]
  }[];
}

@Injectable({
  providedIn: 'root'
})
export class SectorAirGroupService {
  private marriageGroupCheckedSubject$: Subject<string | boolean> = new Subject();
  public marriageGroupCheckedObs: Observable<string | boolean> = this.marriageGroupCheckedSubject$.asObservable();
  private updateSectorsCheckedSubject$: Subject<string[]> = new Subject();
  public updateSectorsCheckedObs: Observable<string[]> = this.updateSectorsCheckedSubject$.asObservable();
  public sectorXIds: string[] = [];

  public updateSectorXIds(event: string | string[] | null): void {
    if (event === null) {
      this.sectorXIds = [];
      this.marriageGroupCheckedSubject$.next(false);
    } else if (Array.isArray(event)) {
      this.sectorXIds = event;
      this.marriageGroupCheckedSubject$.next(true);
    } else {
      if (this.sectorXIds.includes(event)) {
        this.sectorXIds.splice(this.sectorXIds.indexOf(event), 1);
      } else {
        this.sectorXIds.push(event);
      }
    }
    this.updateSectorsCheckedSubject$.next(this.sectorXIds);
  }

  public updateSectorMarriageGroups(marriageGroup: string): void {
    this.marriageGroupCheckedSubject$.next(marriageGroup);
  }
}
